import React, { useState } from 'react';
import './CallToAction.css';
import { useLanguage } from '../contexts/LanguageContext';
import ContactModal from './ContactModal';

const CallToAction = () => {
  const { t } = useLanguage();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  
  const handleContactClick = () => {
    setIsContactModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsContactModalOpen(false);
  };
  
  return (
    <>
      <section className="call-to-action">
        <div className="container">
          <div className="cta-content">
            <div className="cta-logo">
              <img src="/images/Group 1000003026.png" alt="PhiAI Logo" className="cta-logo-image" />
            </div>
            <h2 className="cta-title">{t('callToAction.title')}</h2>
            <p className="cta-subtitle">{t('callToAction.subtitle')}</p>
            <button className="cta-button" onClick={handleContactClick}>
              {t('callToAction.button')}
            </button>
          </div>
        </div>
      </section>
      
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={handleCloseModal} 
      />
    </>
  );
};

export default CallToAction; 